import CenterMiddle from "../../generic/CenterMiddle";

function ErrorPage(){
    return <CenterMiddle>
        <h2>Hey there, we couldn't find the right page for you!</h2>
        <div style={{marginTop:"15px"}}>It's not you, it's us! Get in <a href="https://www.joinstepladder.com/contact/">contact with us</a> to resolve this..</div>
    </CenterMiddle>
}

export default ErrorPage;